<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460">
		<v-card>
			<v-card-title class="h6 justify-start">Konfirmasi</v-card-title>
			<v-card-text class="text-left">
				<div class="d-block text-left" v-html="msg"></div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn :color="(status === 'sukses') ? 'primary' : 'error'" depressed class="text-capitalize" :loading="btnLoading" @click.stop="confirm">{{ confirmText }}</v-btn>
				<v-btn color="grey darken-1" outlined class="text-capitalize" :loading="btnLoading" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			btnLoading: false,
			closeText: 'Batal',
			confirmText: 'Yakin'
		}
	},
	props: {
		msg: String,
		status: String
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
		loadingButton() {
			this.btnLoading = true
		},
		normalButton() {
			this.btnLoading = false
		},
		confirm() {
			this.$emit('action')
		}
	}
};
</script>